import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-0 text-sm text-gray-600" }
const _hoisted_2 = {
  "data-hint-tail": "",
  class: "whitespace-nowrap"
}

import { computed } from 'vue'

import HelpHint from '@/components/neue/wizard/HelpHint.vue'


export default {
  __name: 'TextWithHint',
  props: {
  text: { type: String, required: true },
  label: { type: String, required: true },
  hint: { type: String, required: true }
},
  setup(__props) {

const props = __props

const parts = computed(() => {
  const cut = props.text.lastIndexOf(' ') + 1
  return { head: props.text.slice(0, cut), tail: props.text.slice(cut) }
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(parts.value.head), 1),
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(parts.value.tail), 1),
      _createVNode(HelpHint, {
        class: "ml-1",
        label: __props.label,
        text: __props.hint
      }, null, 8, ["label", "text"])
    ])
  ]))
}
}

}